import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e0fcccf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job_card_header_badge" }
const _hoisted_2 = {
  key: 0,
  class: "job_card_badge_label is-commit-interview"
}
const _hoisted_3 = {
  key: 1,
  class: "job_card_badge_label is-best-recommend"
}
const _hoisted_4 = {
  key: 2,
  class: "job_card_badge_label is-recommend"
}
const _hoisted_5 = {
  key: 3,
  class: "job_card_badge_label is-passing-document-70-over"
}
const _hoisted_6 = { key: 4 }
const _hoisted_7 = {
  key: 5,
  class: "job_card_badge_label is-ai-match"
}
const _hoisted_8 = { key: 6 }
const _hoisted_9 = {
  key: 7,
  class: "job_card_badge_label is-unread"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseJobBadge',
  props: {
  badge: {
    type: Number,
    default: 0,
  },
  aiMatchBadge: {
    type: Number,
    default: 0,
  },
  unread: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.badge === 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "面接確約"))
      : (props.badge === 2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "CAイチオシ"))
        : (props.badge === 3)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "おすすめ"))
          : (props.badge === 4)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "書類通過率70％以上"))
            : _createCommentVNode("", true),
    (props.badge !== 0 && props.aiMatchBadge === 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " "))
      : _createCommentVNode("", true),
    (props.aiMatchBadge === 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "AIマッチ"))
      : _createCommentVNode("", true),
    (( props.badge !== 0 || props.aiMatchBadge === 1 ) && props.unread)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " "))
      : _createCommentVNode("", true),
    (props.unread)
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "未読"))
      : _createCommentVNode("", true)
  ]))
}
}

})